import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "open",
  "use": "open-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"open\"><path fill-rule=\"evenodd\" d=\"M17.993 7V2.5c0-.277-.222-.5-.5-.5h-4.5c-.277 0-.5.222-.5.5s.223.5.5.5h3.246l-8.392 8.392a.5.5 0 1 0 .707.707l8.44-8.44V7a.5.5 0 1 0 1 0ZM14 16l-9.033.017a.984.984 0 0 1-.983-.984L4 6c0-.543.457-1 1-1h4.5V4H5C3.913 4 3 5.11 3 6.197v8.836C3 16.119 3.881 17 4.967 17h8.836C14.889 17 16 16.086 16 15v-4.5h-1V15c0 .543-.457 1-1 1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol